import { ViewCustomer } from "collins-js-sdk";

export const getCustomerName = (selectedCustomer?: ViewCustomer): string => {
  let name = "";

  if (!!selectedCustomer?.firstName || !!selectedCustomer?.lastName) {
    name = `${selectedCustomer.firstName ?? ""} ${
      selectedCustomer.lastName ?? ""
    }`.trim();
  }

  return name;
};
